import { render, staticRenderFns } from "./MetricSelector.vue?vue&type=template&id=5bf634ce&scoped=true"
import script from "./MetricSelector.vue?vue&type=script&lang=js"
export * from "./MetricSelector.vue?vue&type=script&lang=js"
import style0 from "./MetricSelector.vue?vue&type=style&index=0&id=5bf634ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf634ce",
  null
  
)

export default component.exports